import { Empty } from "antd";

export const EmptyDataLabel = () => {
  return (
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Keine Daten" />
  );
};
